module.exports = __webpack_public_path__ + "static/media/perfil_default.75309cd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/perfil_default.png
// module id = 815
// module chunks = 0